import { renderSlot as _renderSlot, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "confirm-message" }
const _hoisted_2 = { class: "confirm-button-frame" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("はい ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("いいえ ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_white_backdrop = _resolveComponent("white-backdrop")

  return (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
    _createVNode(_component_white_backdrop, { show: _ctx.show }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode("div", {
          class: ["confirm-frame", _ctx.$mq]
        }, [
          _createVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_normal_button, {
              type: "button",
              class: "confirm-button",
              state: "confirm",
              onClick: _ctx.onYes
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick"]),
            (!_ctx.yesOnly)
              ? (_openBlock(), _createBlock(_component_normal_button, {
                  key: 0,
                  type: "button",
                  class: "confirm-button",
                  state: "confirm",
                  onClick: _ctx.onNo
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ], 2), [
          [_vShow, _ctx.show]
        ])
      ]),
      _: 3
    }, 8, ["show"])
  ]))
}